import { render, staticRenderFns } from "./TableCatalogComponent.vue?vue&type=template&id=04342f50&"
import script from "./TableCatalogComponent.vue?vue&type=script&lang=js&"
export * from "./TableCatalogComponent.vue?vue&type=script&lang=js&"
import style0 from "./TableCatalogComponent.vue?vue&type=style&index=0&id=04342f50&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports